import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropArray, defaultPropObject } from "../constants";
import { useMediaQuery } from "../hooks";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import HeaderPopup from '../HeaderPopup';
import MenuLinks from '../MenuLinks';
import Popover from '../Popover';
import { additionalCurrencies, defaultCurrencies } from './constants';
import styles from './CurrencySelect.css';
var cx = classNames.bind(styles);
export var CurrencySelect = function CurrencySelect(_ref) {
  var align = _ref.align,
      currency = _ref.currency,
      _ref$currencies = _ref.currencies,
      currencies = _ref$currencies === void 0 ? defaultPropArray : _ref$currencies,
      onChange = _ref.onChange,
      style = _ref.style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Выберите валюту' : _ref$title,
      namespace = _ref.namespace,
      closeOnSelect = _ref.closeOnSelect,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes;
  var breakpoints = useMediaQuery('xs1', 'xs');
  var isMobile = breakpoints.xs;
  var isSmallMobile = breakpoints.xs1;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'currencySelect'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  var toggler = /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', classes.root),
    style: style
  }, getTestId()), currency);
  var items = useMemo(function () {
    return [].concat(_toConsumableArray(defaultCurrencies), _toConsumableArray(additionalCurrencies)).filter(function (label) {
      return currencies.includes(label.code);
    }).map(function (item) {
      return _objectSpread({
        key: item.code,
        onClick: function onClick() {
          onChange(item.code);

          if (closeOnSelect) {
            setIsOpen(false);
          }
        }
      }, isMobile ? {
        children: item.label,
        hint: item.code
      } : {
        children: "".concat(item.code, " \u2014 ").concat(item.label)
      });
    });
  }, [closeOnSelect, currencies, isMobile, onChange]);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    align: align,
    toggler: toggler,
    isOpen: isOpen,
    onToggle: setIsOpen,
    gap: 24
  }, isSmallMobile ? {
    align: 'left'
  } : {}), /*#__PURE__*/React.createElement(HeaderPopup, _extends({
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, isMobile ? {
    size: 'small'
  } : {
    title: title
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('popup')
  }, /*#__PURE__*/React.createElement(MenuLinks, {
    links: items,
    namespace: getNamespace()
  }))));
};
export default CurrencySelect;